import type { UseFinancingsParams } from '~/store-v2/financings/useFinancings'
import type { ComboTypeFilter } from '~/utils/financing-flow/comboType'
import type { SelectedFilters } from '~/utils/financing-flow/Financing'
import { COMBO_TYPE_FILTER, comboTypeToParams } from '~/utils/financing-flow/comboType'

interface UseFinancingFiltersOptions {
  initialParams: UseFinancingsParams
}

export function useFinancingFilters(options: UseFinancingFiltersOptions) {
  const params = ref<UseFinancingsParams>(options.initialParams)

  function applyFilters(selectFilters?: SelectedFilters & { query?: string }) {
    if (!selectFilters)
      return

    let stepsArray: string[] = []
    if (Array.isArray(selectFilters.steps)) {
      stepsArray = selectFilters.steps.map(s => s.value)
    }
    else if (typeof selectFilters.steps === 'object' && selectFilters.steps && 'value' in selectFilters.steps) {
      stepsArray = [selectFilters.steps.value]
    }

    let statusArray: string[] = []
    if (Array.isArray(selectFilters.status)) {
      statusArray = selectFilters.status.map(s => s.value)
    }
    else if (typeof selectFilters.status === 'object' && selectFilters.status) {
      statusArray = [selectFilters.status.value]
    }

    params.value = {
      ...params.value,
      steps: stepsArray,
      status: statusArray,
      query: selectFilters.query || '',
      page: 1,
      is_installed: undefined,
      formalized_lte: undefined,
      formalized_gte: undefined,
      is_expired: undefined,
      is_canceled: undefined,
    } as UseFinancingsParams
  }

  function clearFilters() {
    params.value = {
      ...params.value,
      page: 1,
      steps: [],
      status: [],
      query: '',
      is_installed: undefined,
      formalized_lte: undefined,
      formalized_gte: undefined,
      is_expired: undefined,
      is_canceled: undefined,
      partner_id: params.value.partner_id,
      page_size: params.value.page_size,
      provider: params.value.provider,
      order_by: params.value.order_by,
      ...comboTypeToParams(COMBO_TYPE_FILTER.ALL),
    }
  }

  function applyComboType(type: ComboTypeFilter) {
    params.value = {
      ...params.value,
      ...comboTypeToParams(type),
      page: 1,
    }
  }

  function handleQuickFilterChange(quickParams: Partial<UseFinancingsParams>) {
    params.value = {
      ...params.value,
      ...quickParams,
    }
  }

  function setParams(newParams: UseFinancingsParams) {
    params.value = {
      ...params.value,
      ...newParams,
    }
  }

  return {
    params,
    applyFilters,
    applyComboType,
    clearFilters,
    handleQuickFilterChange,
    setParams,
  }
}
